import React from 'react';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CatalogItemViewContext, ICatalogItemViewContext } from 'src/entities/catalog/item';

import { ResumeV2 } from 'src/widgets/resume';
import VacancyView from './view.vacancy';

const value: ICatalogItemViewContext = {
  [CatalogItemType.Resume]: ResumeV2,
  [CatalogItemType.Vacancy]: VacancyView,
};

export const CatalogItemViewsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <CatalogItemViewContext.Provider value={value}>{children}</CatalogItemViewContext.Provider>;
};
